import angular from 'angular';
import { submitRating } from '../../../modules/call/actions/index';
import { utils } from '../../../modules/core';
import { constants, helpers } from '../../../modules/dokbot';
export class DokbotPatientSurveyService {
    constructor($window, $timeout, $ngRedux) {
        this.$window = $window;
        this.$timeout = $timeout;
        this.$ngRedux = $ngRedux;
        this.SURVEY_LAUNCH_DELAY = 3000;
        this.launcher = null;
        this.trackData = {
            rating: null,
            data: null,
            comment: null,
            plan_type: undefined,
        };
        this.initLauncher();
    }
    initLauncher() {
        if (!this.isSupported()) {
            helpers.dokbotTrackError(constants.DOKBOT_TYPE_POSTCALL);
            return;
        }
        this.launcher = this.$window.Dokbot.RuntimeComponent.overlay({
            workflowId: 'patient-call-quality',
            consultationId: '+',
            closeButton: true,
            closeOnExit: true,
            params: { surveyData: {} },
            onEvent: ({ name, value }) => {
                this.formatTrackData(name, value);
            },
            onCompletion: () => {
                this.sendTrackData();
            },
            errorKitOverride: {
                id: constants.DOKBOT_KIT_ID,
                url: constants.DOKBOT_KIT_URL,
            },
        }, {
            preload: true,
            overlayCloseable: false,
            explosionColor: '#0f1722',
        });
    }
    launchSurvey() {
        if (!this.isSupported())
            return;
        this.launcher();
    }
    launchDelayedOneIn({ oneInNumber, customDelay, }) {
        let shouldBeShowed = Math.floor(Math.random() * oneInNumber) === 0;
        if (localStorage && localStorage.getItem('testing-always-show-survey')) {
            shouldBeShowed = true;
        }
        if (shouldBeShowed) {
            this.$timeout(() => this.launchSurvey(), customDelay ? customDelay : this.SURVEY_LAUNCH_DELAY);
        }
    }
    formatTrackData(name, value) {
        if (name === 'rating') {
            this.trackData.rating = value;
            return;
        }
        if (name === 'comment') {
            this.trackData.comment = value;
            return;
        }
        if (typeof value === 'number') {
            this.trackData[name] = value;
        }
        else if (Array.isArray(value)) {
            if (!this.trackData.data) {
                this.trackData.data = [];
            }
            this.trackData.data = [...this.trackData.data, ...value];
        }
        else if (typeof value === 'string') {
            if (!this.trackData.data) {
                this.trackData.data = [];
            }
            this.trackData.data.push(value);
        }
    }
    sendTrackData() {
        this.trackData.data = [...new Set(this.trackData.data)];
        this.trackData.data = this.trackData.data.map((el) => utils.spacedToSnakeCase(el));
        this.trackData.comment = this.trackData.comment || null;
        this.$ngRedux.dispatch(submitRating({
            rating: this.trackData.rating,
            data: this.trackData.data,
            comment: this.trackData.comment,
            isProviderFeedback: false,
        }));
        this.cleanupState();
    }
    cleanupState() {
        Object.keys(this.trackData).forEach((key) => (this.trackData[key] = null));
    }
    isSupported() {
        return this.$window.Dokbot && this.$window.Dokbot.meta.isBrowserSupported;
    }
}
export default angular
    .module('doxy.common.services.DokbotPatientSurveyService', [])
    .service('DokbotPatientSurveyService', DokbotPatientSurveyService).name;
